export default {
  computed: {
    matchedBreakpoint () {
      return this.$mq.all[this.$mq.all.length - 1]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/getMatchedBreakpoint.js